export const OAUTH_POST_MESSAGE_NAME = 'THIRD_PARTY_OAUTH_RESULT';
